import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SharedServiceHelperService {
    private _useSharedServices = true;

    constructor() { }

    getSharedServicesEnabled() {
        return this._useSharedServices;
    }
}
